module.exports = __webpack_public_path__ + "img/hy_m_img1.25b38b64.jpg";